@if (ngControl.control != null) {
  <textarea
    pInputTextarea
    [autoResize]="autoResize"
    [name]="name"
    [rows]="rows"
    [formControl]="ngControl.control | abstractControlToFormControl"
    [placeholder]="placeholder"></textarea>
}
